import { PlaceValueMat as PlaceValueMatIcon } from "assets/icons";
import {
  DropdownSetting,
  InformationSetting,
  RememberSettings,
  ToggleSetting,
} from "components/settings";
import { WidgetNames } from "constants/widgets";
import { WidgetType } from "types/Widget";

import { PlaceValueMatState, PlaceValueMat } from "./PlaceValueMat";
import { PlaceValueMatNumberSetting } from "./PlaceValueMatNumberSetting";

export const PlaceValueMatWidget: WidgetType<PlaceValueMatState> = {
  name: "Place Value Mat",
  component: PlaceValueMat,
  icon: PlaceValueMatIcon,
  showOnToolbar: true,
  sizing: {
    minWidth: 217,
    minHeight: 87,
    minAspectRatio: 2.5,
    maxAspectRatio: 2.5,
  },
  defaultState: {
    values: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  },
  defaultSize: {
    aspectRatio: 2,
    widthPercentage: 50,
  },
  settings: {
    header: {
      editor: InformationSetting,
      info: {
        info: "Customise how you want to count\n\nSelect how many number columns and the amount of decimals",
      },
    },
    cols: {
      editor: DropdownSetting,
      info: {
        name: "Number Columns",
        options: [
          "Millions (1,000,000)",
          "Hundreds of Thousands (100,000)",
          "Tens of Thousands (10,000)",
          "Thousands (1,000)",
          "Hundreds (100)",
          "Tens (10)",
          "Ones (1)",
        ],
      },
      defaultValue: "Thousands (1,000)",
    },
    decimals: {
      editor: DropdownSetting,
      info: {
        name: "Decimal Places",
        options: ["None", "Tenths (0.1)", "Hundredths (0.01)", "Thousandths (0.001)"],
      },
      defaultValue: "None",
    },
    generate: {
      editor: PlaceValueMatNumberSetting,
      info: {
        label: "Current Number",
        minValue: 0,
        maxValue: 9999999,
      },
      defaultValue: 1000000,
    },
    short: {
      editor: ToggleSetting,
      info: {
        label: "Show Short Names",
      },
      defaultValue: true,
    },
    long: {
      editor: ToggleSetting,
      info: {
        label: "Show long Names",
      },
      defaultValue: false,
    },
    resultFormat: {
      editor: DropdownSetting,
      info: {
        name: "Total Format",
        options: ["With Commas (1,000)", "Without Commas (1000)"],
      },
      defaultValue: "With Commas (1,000)",
    },
    rememberSettings: {
      editor: RememberSettings,
      info: {
        widgetName: WidgetNames.placeValueMat,
        widgetDisplayName: "Place Value Mat",
      },
    },
  },
  quickActions: {},
};
